import React from 'react';
import { Zap } from 'lucide-react';
export function UrgencyBar() {
  return <div className="sticky top-0 z-50 w-full bg-zenith-red text-white py-3 px-4 shadow-lg" data-id="element-70">
      <div className="max-w-4xl mx-auto flex flex-col sm:flex-row items-center justify-center text-center text-sm md:text-base font-medium tracking-wide" data-id="element-71">
        <span className="flex items-center mb-1 sm:mb-0 sm:mr-2" data-id="element-72">
          <Zap className="w-4 h-4 mr-1 fill-current" data-id="element-73" />
          PRECIO DE LANZAMIENTO: $6.83
        </span>
        <span className="hidden sm:inline mx-2 opacity-60" data-id="element-74">|</span>
        <span data-id="element-75">Un Ebook. Un Proceso. Acceso Inmediato.</span>
      </div>
    </div>;
}